import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4da57a9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "input-container"
}
const _hoisted_2 = { class: "infotext" }
const _hoisted_3 = { class: "infotext" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"10px"} }, null, -1))
const _hoisted_5 = { class: "input-fieldset" }
const _hoisted_6 = { for: "register-email" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "input-fieldset" }
const _hoisted_11 = { for: "register-pnumber" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "input-fieldset" }
const _hoisted_16 = { for: "register-pwd" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "input-fieldset" }
const _hoisted_21 = { for: "register-repwd" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"5px"} }, null, -1))
const _hoisted_27 = { class: "infotext" }
const _hoisted_28 = {
  key: 1,
  class: "input-container"
}
const _hoisted_29 = { class: "code-fieldset" }
const _hoisted_30 = { for: "emailcode" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "code-fieldset" }
const _hoisted_36 = { for: "phonecode" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 0,
  style: {"margin-block-end":"0.2em"}
}
const _hoisted_43 = {
  key: 2,
  class: "input-container"
}
const _hoisted_44 = ["disabled"]

import { onMounted, ref } from "vue";
import { index } from '@/store';
import { HttpStatus } from "@/backend/types/response";
import { CognitoService } from "@/backend/cognito";
import { AuthMethod } from "@/backend/types/login";
import { AppState } from "@/store/app-state";
import { translate } from "@/util/intl";
import CustomSpinner from "@/components/CustomSpinner.vue";
import { requiredInject } from "@/util/vue";
import { BackendKey } from "@/backend";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordRegister',
  setup(__props) {

const cognito = new CognitoService();
const backend = requiredInject(BackendKey);

// data refs
const email = ref('');
const pnumber = ref('');
const pwd = ref('');
const repwd = ref('');
const emailcode = ref('');
const phonecode = ref('');
// state refs
const isValidEmail = ref(true);
const isValidPhone = ref(true);
const isValidPassword = ref(true);
const passwordsMatch = ref(true);
const inProcess = ref(false);
const firstStep = ref(true);
const enableCodeInput = ref(false);
const passportButtonOn = ref(false);
const noCodeReceived = ref(false);
const emailCodeFieldDisabled = ref(false);
const smsCodeFieldDisabled = ref(true);
const faultySmsCode = ref(false);
const faultyEmailCode = ref(false);
const recentlySent = ref(false);
const emailVerified = ref(false);

let codeTimeoutId: number; // ID from setTimeout, used for canceling timeout
let passportIdUrl: string; // unique URL that comes from Onfido

onMounted(() => {
  // in case user fails passport id, trigger new url generation in background and jump to last step
  if (index.getters.hasAttemptedPassportId) {
    enablePassportView();
    inProcess.value = true;
    startPassportIdentification()
      .catch(err => {
        console.error("ppiderr_retry " + JSON.stringify(err));
      });
  }
});

// timeout value must match flow session duration in Cognito, idk how to get Cognito itself to tell session ended
function startCodeInputCountdown() {
  if (codeTimeoutId) {
    clearTimeout(codeTimeoutId);
  }
  codeTimeoutId = setTimeout(async () => {
    index.commit("SET_APP_STATE", AppState.Logout);
    await router.push("/logout?expired");
  }, 10 * 60 * 1000);
}

function resetErrors() {
  isValidEmail.value = true;
  isValidPhone.value = true;
  isValidPassword.value = true;
  passwordsMatch.value = true;
}

function enableCodeView() {
  firstStep.value = false;
  enableCodeInput.value = true;
  passportButtonOn.value = false;
  setTimeout(() => {
    noCodeReceived.value = true;
  }, 8000);
  startCodeInputCountdown(); //email 2fa
}

function enablePassportView() {
  firstStep.value = false;
  enableCodeInput.value = false;
  passportButtonOn.value = true;
}

function register(): void {
  resetErrors();
  const emailStr = email.value.trim();
  const phoneStr = pnumber.value.trim();
  const pwdStr = pwd.value.trim();
  if (!cognito.validateEmail(emailStr)) {
    isValidEmail.value = false;
  }
  if (!cognito.validatePhone(phoneStr)) {
    isValidPhone.value = false;
  }
  if (!cognito.validatePassword(pwdStr)) {
    isValidPassword.value = false;
  }
  if (pwdStr !== repwd.value.trim()) {
    passwordsMatch.value = false;
  }
  if (isValidEmail.value && isValidPhone.value && isValidPassword.value && passwordsMatch.value) {
    inProcess.value = true;
    cognito.registerUser(emailStr, phoneStr, pwdStr)
    .then(res => {
      index.commit("SET_USER_COGNITO_ID", res);
      // as register continues to RegisteringI18nRegisteringForm email and phone will be re-used there
      index.commit("SET_USER_EMAIL_ADDRESS", emailStr);
      index.commit("SET_USER_PHONE_NUMBER", phoneStr);
      enableCodeView();
    }, err => {
      if (err.includes("email already exists")) {
        alert("This email has already been registered. Did you mean to login?");
      } else {
        console.error("regerr: " + err);
      }
    })
    .finally(() => {
      inProcess.value = false
    });
  }
}

// once email verification passes, disable its field to prevent confusing users and activate sms verification field
function enablePhoneCodeField() {
  emailVerified.value = true;
  emailCodeFieldDisabled.value = true;
  smsCodeFieldDisabled.value = false;
  startCodeInputCountdown(); //sms 2fa
}

function resendCode() {
  if (emailCodeFieldDisabled.value) {
    resendSmsCode();
  } else {
    resendEmailCode();
  }
  startCodeInputCountdown(); //email or sms 2fa
}

// send registration email code
function verifyEmail() {
  faultySmsCode.value = false;
  faultyEmailCode.value = false;
  cognito.confirmUserRegistrationByCode(emailcode.value, email.value.trim())
    .then(() => {
      // verifying phone with login simultaneously creates active session needed ahead
      cognito.loginUser(email.value.trim(), pwd.value.trim(), enablePhoneCodeField)
        .then(() => {
          // email & sms codes both succeeded, shut down further input possibility
          smsCodeFieldDisabled.value = true;
        }, () => {
          // sms code failed
          faultySmsCode.value = true;
        });
    }, () => {
      // email code failed
      faultyEmailCode.value = true;
    });
}

function resendEmailCode() {
  if (!recentlySent.value) {
    recentlySent.value = true;
    const id = index.getters.getCognitoId;
    if (id !== "") {
      cognito.resendRegistrationConfirmCode(id)
        .catch(err => {
          console.error("resenderr: " + err);
        });
    } else {
      // something wrong with initializing user or user state
      console.error("resend: usererr")
    }
    setTimeout(() => {
      recentlySent.value = false;
    }, 8000);
  }
}

function verifyPhone() {
  if (phonecode.value === "") return;
  faultySmsCode.value = false;
  faultyEmailCode.value = false;
  smsCodeFieldDisabled.value = true;
  inProcess.value = true;
  cognito.submitLoginCode(phonecode.value.trim(), email.value.trim())
    .then(() => {
      clearTimeout(codeTimeoutId);
      startPassportIdentification()
        .catch(err => {
          console.error("ppiderr " + JSON.stringify(err));
        });
    }, () => {
      inProcess.value = false;
      smsCodeFieldDisabled.value = false;
      faultySmsCode.value = true;
    });
}

function resendSmsCode() {
  if (!recentlySent.value) {
    recentlySent.value = true;
    verifyPhone();
    setTimeout(() => {
      recentlySent.value = false;
    }, 8000);
  }
}

function openPassportIdentificationTab(): void {
  // we need a click with current implementation or browser popup blocker blocks it
  window.open(passportIdUrl, '_blank');
  router.push("/login");
}

async function startPassportIdentification(): Promise<void> {
  index.commit("SET_USER_AUTH_METHOD", AuthMethod.COGNITO);
  const response = await backend.initiatePassportValidation();
  switch (response.status) {
    case HttpStatus.CREATED:
      passportIdUrl = response.location; // URL from Cognito
      enablePassportView();
      inProcess.value = false;
      break;
    case HttpStatus.UNAUTHORIZED:
      index.commit("SET_APP_STATE", AppState.Logout);
      await router.replace("/logout?expired");
      break;
    default:
      break;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (firstStep.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_unref(translate)("registering")) + " (1/3)", 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(translate)("register-user-account-1")), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translate)("register-password-info")) + " " + _toDisplayString(_unref(translate)("phone-format-info")), 1),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(translate)("email")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "register-email",
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              disabled: inProcess.value,
              autofocus: ""
            }, null, 8, _hoisted_7), [
              [_vModelText, email.value]
            ]),
            (!isValidEmail.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(translate)("invalid-email")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)("phone-number")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "register-pnumber",
              type: "tel",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pnumber).value = $event)),
              disabled: inProcess.value
            }, null, 8, _hoisted_12), [
              [_vModelText, pnumber.value]
            ]),
            (!isValidPhone.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(translate)("invalid-phone-number")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_14))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)("password")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "register-pwd",
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pwd).value = $event)),
              disabled: inProcess.value
            }, null, 8, _hoisted_17), [
              [_vModelText, pwd.value]
            ]),
            (!isValidPassword.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(translate)("invalid-password")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_19))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)("password-re")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "register-repwd",
              type: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((repwd).value = $event)),
              disabled: inProcess.value
            }, null, 8, _hoisted_22), [
              [_vModelText, repwd.value]
            ]),
            (!passwordsMatch.value && isValidPassword.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(translate)("password-mismatch")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_24))
          ]),
          _createElementVNode("button", {
            class: "buttonContinue",
            onClick: register,
            disabled: inProcess.value
          }, _toDisplayString(_unref(translate)("generic-continue")), 9, _hoisted_25),
          _hoisted_26,
          _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(translate)("register-user-account-2")), 1)
        ]))
      : (enableCodeInput.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("h2", null, _toDisplayString(_unref(translate)("registering")) + " (2/3)", 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h3", null, _toDisplayString(_unref(translate)("give-email-code")), 1),
              _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)("auth-code")) + " (Email)", 1),
              _withDirectives(_createElementVNode("input", {
                id: "emailcode",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((emailcode).value = $event)),
                onKeyup: _withKeys(verifyEmail, ["enter"]),
                disabled: emailCodeFieldDisabled.value,
                autofocus: ""
              }, null, 40, _hoisted_31), [
                [_vModelText, emailcode.value]
              ]),
              (faultyEmailCode.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_unref(translate)("faulty-mfa-code")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_33)),
              _createElementVNode("button", {
                class: "buttonContinue",
                onClick: verifyEmail,
                disabled: emailCodeFieldDisabled.value
              }, _toDisplayString(_unref(translate)("verify")), 9, _hoisted_34)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("h3", null, _toDisplayString(_unref(translate)("give-sms-code")), 1),
              _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)("auth-code")) + " (SMS)", 1),
              _withDirectives(_createElementVNode("input", {
                id: "phonecode",
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phonecode).value = $event)),
                onKeyup: _withKeys(verifyPhone, ["enter"]),
                disabled: smsCodeFieldDisabled.value
              }, null, 40, _hoisted_37), [
                [_vModelText, phonecode.value]
              ]),
              (faultySmsCode.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_unref(translate)("faulty-mfa-code")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_39)),
              _createElementVNode("button", {
                class: "buttonContinue",
                onClick: verifyPhone,
                disabled: smsCodeFieldDisabled.value
              }, _toDisplayString(_unref(translate)("verify")), 9, _hoisted_40)
            ]),
            (noCodeReceived.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (!emailVerified.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_unref(translate)("check-junkmail")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: "alink",
                    href: "#",
                    onClick: resendCode
                  }, _toDisplayString(_unref(translate)("no-code-received-q")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (passportButtonOn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("h3", null, _toDisplayString(_unref(translate)("passport-verification-begin")) + " (3/3)", 1),
              _createElementVNode("p", null, _toDisplayString(_unref(translate)("passport-verification-guidetext")), 1),
              _createElementVNode("button", {
                class: "buttonContinue",
                onClick: openPassportIdentificationTab,
                disabled: inProcess.value
              }, _toDisplayString(_unref(translate)("generic-continue")), 9, _hoisted_44)
            ]))
          : _createCommentVNode("", true),
    _createVNode(CustomSpinner, { loading: inProcess.value }, null, 8, ["loading"])
  ], 64))
}
}

})